// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCjw3sOPxDz-FfO01au-7BvMQ2K9CrX8lA",
  authDomain: "coeflairweb.firebaseapp.com",
  projectId: "coeflairweb",
  storageBucket: "coeflairweb.firebasestorage.app",
  messagingSenderId: "949755125429",
  appId: "1:949755125429:web:df7f5ccb3fe4098b45a8fc",
  measurementId: "G-1ECJRVSMFG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
